import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import { NavLink } from 'react-router-dom';

const Login = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState({ email: "", password: "" });
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const submitForm = async (e) => {
    e.preventDefault();
    const sendData = { email: user.email, password: user.password };
  
    try {
      const result = await axios.post("https://api.mitradingjp.com/login.php", sendData);
      console.log("API Response:", result.data);
  
      if (result.data.Status === "200") {
        // Store all necessary user information
        window.localStorage.setItem("token", result.data.token);
        window.localStorage.setItem("email", result.data.email);
        window.localStorage.setItem("userName", result.data.fname + " " + result.data.lname);
        window.localStorage.setItem("usertype", result.data.usertype);
        window.localStorage.setItem("fname", result.data.fname);
        window.localStorage.setItem("lname", result.data.lname);
        
        // We need to store the user ID - we'll modify login.php to return it
        if (result.data.id) {
          window.localStorage.setItem("userId", result.data.id);
        }
  
        console.log("Redirecting to /admin-panel...");
        navigate("/admin-panel");
      } else {
        setError(result.data.Message || "Login failed.");
      }
    } catch (err) {
      console.error("Login error:", err);
      setError("Your account is not yet activated. Don't hesitate to get in touch with your administrator.");
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "repeating-linear-gradient(45deg, #f7f7f7, #f7f7f7 15px, #eaeaea 15px, #eaeaea 30px)",
      }}
    >
      {/* Error message outside the circle */}
      {error && (
        <div
          className="alert alert-danger"
          style={{
            width: "50%",
            textAlign: "center",
            padding: "10px",
            marginBottom: "20px", // Space out the alert from the circle
            fontSize: "1.3rem",
            position: "absolute", // Position the alert outside of the circle
            top: "22%", // Set the vertical position of the alert
          }}
        >
          {error}
        </div>
      )}

      {/* Circular container */}
      <div
        style={{
          width: "360px",
          height: "360px",
          backgroundColor: "#147D9B", // teal-like color
          borderRadius: "50%",
          position: "relative",
          boxShadow: "10px 10px 2px rgba(0,0,0,0.1)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          paddingTop: "40px",
          paddingBottom: "20px",
        }}
      >
        <NavLink to="/mijapan-auction"><h2 style={{ color: "#fff", marginBottom: "8px" }}>Sign up!</h2></NavLink>
        <p style={{ color: "#fff", margin: 0, fontSize: "0.85rem" }}>
          Enter your credentials
        </p>

        {/* Form */}
        <form
          onSubmit={submitForm}
          style={{
            width: "70%",
            display: "flex",
            flexDirection: "column",
            marginTop: "15px",
          }}
        >
          {/* Username (email) field */}
          <div style={{ position: "relative", marginBottom: "15px" }}>
            <input
              id="email"
              className="form-control"
              style={{
                paddingLeft: "36px",
                borderRadius: "20px",
                border: "none",
                boxShadow: "0 0 5px rgba(0,0,0,0.1)",
                backgroundColor: "#5CA3B7",
                color: "#A9E5F0"
              }}
              type="email"
              name="email"
              onChange={handleChange}
              value={user.email}
              required
              placeholder="Username"
            />
            {/* Icon on the left */}
            <i
              className="bi bi-person-fill"
              style={{
                position: "absolute",
                top: "50%",
                left: "10px",
                transform: "translateY(-50%)",
                color: "#999",
              }}
            />
          </div>

          {/* Password field */}
          <div style={{ position: "relative", marginBottom: "15px" }}>
            <input
              id="password"
              className="form-control"
              style={{
                paddingLeft: "36px",
                borderRadius: "20px",
                border: "none",
                boxShadow: "0 0 5px rgba(0,0,0,0.1)",
                backgroundColor: "#5CA3B7",
                color: "#A9E5F0"
              }}
              type="password"
              name="password"
              onChange={handleChange}
              value={user.password}
              required
              placeholder="Password"
            />
            {/* Icon on the left */}
            <i
              className="bi bi-lock-fill"
              style={{
                position: "absolute",
                top: "50%",
                left: "10px",
                transform: "translateY(-50%)",
                color: "#999",
              }}
            />
          </div>

          {/* Submit button */}
          <button
            style={{
              width: "100%",
              backgroundColor: "#8CC63F", // greenish button
              color: "#fff",
              border: "none",
              borderRadius: "20px",
              padding: "10px 0",
              fontWeight: "bold",
              boxShadow: "0 0 5px rgba(0,0,0,0.2)",
            }}
            type="submit"
          >
            Log in
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
